import api from '@/api'
import store from '@/store'

export default {
  async init() {
    const [err, mainConfig] = await api.get('setup/main.config.json').send()

    if (!err && mainConfig) {
      store.dispatch('setMainConfig', mainConfig)
    }
  },

  getMainConfig() {
    return store.state.mainConfig
  },
}
